import { SET_ADDED_TO_CART } from './../const';

export default (addedToCart) => {
    return {
      type: SET_ADDED_TO_CART,
      addedToCart: addedToCart
    }
};
